import theme from '~lib/styles/Theme';

export const DEFAULT_OPTIONS = {
  maintainAspectRatio: false,
  devicePixelRatio: 2,
  animation: {
    duration: 0,
  },
  interaction: {
    intersect: false,
    mode: 'index',
  },
  plugins: {
    legend: {
      display: false,
    },
    tooltip: {
      enabled: false,
    },
    datalabels: {
      labels: {
        value: {
          color: theme.colors.gray800,
          align: 'end',
          anchor: 'end',
          font: {
            weight: '500',
            lineHeight: '12px',
            size: '10px',
            family: 'Pretendard',
          },
          formatter: (value: number, isActiveUser: boolean) => {
            if (!isActiveUser) {
              return '??년';
            }

            if (value === 0) {
              return '데이터 없음';
            }

            return `${value}년`;
          },
        },
      },
    },
  },
  scales: {
    x: {
      grid: {
        display: false,
      },
      ticks: {
        font: {
          weight: '500',
          lineHeight: '12px',
          size: '10px',
          family: 'Pretendard',
        },
        color: theme.colors.gray700,
      },
    },
    y: {
      grid: {
        drawBorder: false,
        display: false,
      },
      ticks: {
        display: false,
      },
    },
  },
};
